import React from "react";
import ReactDOM from 'react-dom';
import { createAuth0Client } from '@auth0/auth0-spa-js';
import $ from 'jquery';
import AlertDismissable from './components/AlertDismissable';
import MainInterface from './components/MainInterface';

const AUTH0_CLIENT_ID = "g8LMgJZ9AzMfQeRa93e9aUeR58ERZXe2";
const AUTH0_DOMAIN = "chcrawl.auth0.com";
const AUTH0_CALLBACK_URL = window.location.href;
const AUTH0_API_AUDIENCE = "https://chcrawl.auth0.com/api/v2/";
const AUTH0_SCOPE = "openid profile email offline_access";

const authParams = {
  authorizationParams: {
    audience: AUTH0_API_AUDIENCE,
    scope: AUTH0_SCOPE,
    redirect_uri: AUTH0_CALLBACK_URL,
  }
};

class App extends React.Component {

  constructor(props) {
    super(props);
    this.authenticate = this.authenticate.bind(this);
    this.setup = this.setup.bind(this);
    this.displayFeedback = this.displayFeedback.bind(this);
    this.timer = null;
    this.auth0 = null;
    this.loggedIn = false;
    this.mainInterface = null;
    this.hideModals = this.hideModals.bind(this);
    this.displayFeedback = this.displayFeedback.bind(this);
  }

  async authenticate(redirect = false) {
    try {
      // Initialize Auth0 client if not already done
      if (!this.auth0) {
        this.auth0 = await createAuth0Client({
          domain: AUTH0_DOMAIN,
          clientId: AUTH0_CLIENT_ID,
          cacheLocation: "localstorage",
          useRefreshTokens: true,
          scope: AUTH0_SCOPE,
          audience: AUTH0_API_AUDIENCE,
        });
      }

      const query = window.location.search;

      // Handle redirect callback
      if (query.includes("code=") && query.includes("state=")) {
        await this.auth0.handleRedirectCallback();
        window.history.replaceState({}, document.title, "/");
        this.loggedIn = await this.auth0.isAuthenticated();
        if (this.loggedIn) {
          this.accessToken = await this.auth0.getTokenSilently(authParams);
          this.setup(this.displayFeedback);
          this.setState({ loggedIn: true });
        }
        return;
      }

      if (redirect) {
        await this.auth0.loginWithRedirect(authParams);
        return; // Login with redirect will handle the rest
      }

      // Check if already authenticated
      this.loggedIn = await this.auth0.isAuthenticated();
      if (this.loggedIn) {
        this.accessToken = await this.auth0.getTokenSilently(authParams);
        this.setup(this.displayFeedback);
        this.setState({ loggedIn: true });
      }
    } catch (err) {
      console.error("Authentication error:", err);
    }
  }

  scheduleTokenRenewal() {
    const delay = 300000; // renew token every 5 minutes
    this.timer = setTimeout(() => this.renewToken(), delay);
  }

  async renewToken() {
    try {
      this.accessToken = await this.auth0.getTokenSilently(authParams);
      this.scheduleTokenRenewal();
    } catch (err) {
      console.error("Error renewing token:", err);
    }
  }

  componentDidMount() {
    this.authenticate();
    this.scheduleTokenRenewal();
    // document.body.setAttribute('data-bs-theme', 'dark');
    // document.body.classList.add('bg-dark');
    // document.body.classList.add('text-light');
  }
  
  componentWillUnmount() {
    clearTimeout(this.timer);
    // document.body.removeAttribute('data-bs-theme');
    // document.body.classList.remove('bg-dark');
    // document.body.classList.remove('text-light');
  }

  setup(displayFeedback) {
    $.put = function (url, data, callback, type) {

      if ($.isFunction(data)) {
        type = type || callback;
        callback = data;
        data = {};
      }

      return $.ajax({
        url: url,
        type: 'PUT',
        success: callback,
        error: this.ajaxErrorHandler,
        data: data,
        contentType: type
      });
    }

    $.delete = function (url, data, callback, type) {

      if ($.isFunction(data)) {
        type = type || callback;
        callback = data;
        data = {};
      }

      return $.ajax({
        url: url,
        type: 'DELETE',
        success: callback,
        error: this.ajaxErrorHandler,
        data: data,
        contentType: type
      });
    }

    let parent_state = this;

    // provide a wrapper around all binary data requests to handle
    // authentication and error handling
    $.getBinary = function (url, data, callback, type) {
      if ($.isFunction(data)) {
        type = type || callback;
        callback = data;
        data = {};
      }

      var request = new XMLHttpRequest();
      request.open('GET', url, true);
      request.responseType = 'arraybuffer';
      request.setRequestHeader(
        "Authorization",
        "Bearer " + parent_state.accessToken
      );
      
      // create the call back here so the closure magic keeps access to 'this' 
      request.onload = function () {
        var buffer = this.response,
          binary = '',
          bytes = new Uint8Array(buffer),
          len = bytes.byteLength;

        for (var i = 0; i < len; i++) {
          binary += String.fromCharCode(bytes[i]);
        }
        if (request.status >= 200 && request.status < 400) {
          callback(btoa(binary));
        } else if (request.status == 500) {
          displayFeedback("Fatal server failure. Please contact the system administrator", "failure");
        } else {
          try {
            var jsonData = JSON.parse(binary)
            if ("message" in jsonData) {
              displayFeedback(jsonData["message"], "failure");
            }
          } catch (err) {
          }
        }
      };
      request.send();
    }

    // provide a wrapper around all ajax requests to add authentication 
    // and provide error message handling
    $.ajaxSetup({
      beforeSend: (r) => {
        r.setRequestHeader(
          "Authorization",
          "Bearer " + this.accessToken
        );
      },
      statusCode: {
        401: function () {
          // request wasn't authorized so users session is probably expired
          // refresh the page to display the login screen
          window.location.reload();
        },
        400: (xhr) => {
          displayFeedback(xhr.responseJSON["message"], "failure");
        },
        403: (xhr) => {
          displayFeedback(xhr.responseJSON["message"], "failure");
        },
        422: (xhr) => {
          displayFeedback(xhr.responseJSON["message"], "failure");
        },
        500: (xhr) => {
          this.hideModals();
          displayFeedback("Fatal server failure. Please contact the system administrator", "failure");
        }
      }
    });
  }
  ajaxErrorHandler(xhr, textStatus, errorThrown){
    var prefix = "Unknown error occurred.";
    if (xhr.status === 500) {
      prefix = "Fatal server failure.";
    }
    var message = "";
    if (xhr.responseJSON) {
      message = xhr.responseJSON["message"]
    } else if (xhr.responseText) {
      message = xhr.responseText;
    } 
    this.displayFeedback(prefix + " " + message + " Please contact the system administrator", "failure");
  }
  displayFeedback(message, status) {
    this.feedback.showHandler(message, status);
  }
  hideModals() {
    if (this.mainInterface) {
      this.mainInterface.hideModals();
    }
  }
  render() {
    if (this.loggedIn) {
      return (
        <div className="container">
          <AlertDismissable ref={instance => { this.feedback = instance; }} timeout={2000} />
          <MainInterface displayFeedback={this.displayFeedback} ref={instance => { this.mainInterface = instance; }} />
        </div>
      );
    }
    return (
      <div className="container">
        <div className="row justify-content-md-center">
            <div className="col-xs-8 col-xs-offset-2 jumbotron text-center">
                <h1>Extraction Designer</h1>
                <p>Sign in to develop web extraction scripts</p>
                <a
                    onClick={this.authenticate}
                    className="btn btn-primary btn-lg btn-login btn-block"
                >
                    Sign In
                </a>
            </div>
        </div>
      </div>
    )
  }
}

ReactDOM.render(<App />, document.getElementById('app'));